// extracted by mini-css-extract-plugin
export var container = "_15-0";
export var icon = "_15-1";